import { useQuery } from '@tanstack/react-query';
import { getContactDetails as getContactDetailsService } from 'services/api/ContactServiceAPI';
import { queryKeys } from '../queryKeys';

export const useGetContactDetails = ({ id = '', isEnabled }: { id?: string; isEnabled: boolean }) => {
    const {
        data: contactDetails,
        isLoading: isContactDetailsLoading,
        refetch: refetchContactDetails,
    } = useQuery({
        queryKey: queryKeys.contactDetails(id),
        queryFn: () => getContactDetailsService(id),
        enabled: isEnabled,
    });

    return { contactDetails, isContactDetailsLoading, refetchContactDetails };
};
